import { Box, Typography } from '@mui/material';
import { styles } from './styles';

export const RoundedBar = (props) => {
    const { x, y, width, height, fill } = props;
    const r = 4; // border radius
    if (!height || height <= 0) return null;
    return (
        <path
            d={`M${x},${y + height} 
          L${x},${y + r} 
          Q${x},${y} ${x + r},${y} 
          L${x + width - r},${y} 
          Q${x + width},${y} ${x + width},${y + r} 
          L${x + width},${y + height} Z`}
            fill={fill}
        />
    );
};

export const ChartLegend = ({
    currentColor,
    prevColor,
    currentLabel = 'Current Day',
    prevLabel = 'Prev Day',
    avgCWColor = '#1a2d45',
    avgPWColor = '#e07b39'
}) => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
        {[
            { label: currentLabel, color: currentColor, type: 'bar' },
            { label: prevLabel, color: prevColor, type: 'bar' },
        ].map(({ label, color, type }) => (
            <Box key={label} sx={{ display: 'flex', alignItems: 'center', gap: 0.5, }}>
                {type === 'bar' ? (
                    <Box sx={{ width: 12, height: 12, borderRadius: 0.5, background: color }} />
                ) : type === 'line' ? (
                    <Box sx={{ width: 18, height: 2, background: color }} />
                ) : (
                    <Box sx={{ width: 18, height: 2, borderTop: `2px dashed ${color}` }} />
                )}
                <Typography sx={{ fontSize: 14, color: '#5a6a7a' }}>{label}</Typography>
            </Box>
        ))}
    </Box>
);


export const DeltaRow = ({ deltas }) => (
    <Box sx={styles.deltaRow}>
        {deltas.map(({ day, delta }) => {
            const isPositive = delta >= 0;
            return (
                <Box key={day} sx={styles.deltaChip}>
                    <Typography sx={{ fontSize: 15, color: isPositive ? '#22a35a' : '#e53935', fontWeight: 600 }}>
                        {isPositive ? '▲' : '▼'}{isPositive ? '+' : ''}{delta} {day}
                    </Typography>
                </Box>
            );
        })}
    </Box>
);

export const BarTopLabel = (props) => {
    const { x, y, width, value, index, data, dataKey, compareKey } = props;
    if (value == null) return null;

    if (!compareKey) {
        return (
            <text
                x={x}
                y={y - 6}
                fill="#888"
                textAnchor="middle"
                fontSize={14}
                fontWeight={600}
            >
                {value}
            </text>
        );
    }

    const scheduledValue = data?.[index]?.[compareKey];
    const shortfall = scheduledValue != null ? scheduledValue - value : null;
    const pct = scheduledValue ? ((shortfall / scheduledValue) * 100).toFixed(1) : null;
    const missed = shortfall > 0;
    const deltaText = shortfall != null
        ? missed
            ? `▼ ${shortfall} (${pct}% missed)`
            : `all done`
        : null;
    const deltaColor = missed ? "#ef4444" : "#16a34a";

    return (
        <g>
            {/* delta — topmost */}
            {/* {deltaText && (
                <text
                    x={x}
                    y={y - 24}
                    fill={deltaColor}
                    textAnchor="middle"
                    fontSize={13}
                    fontWeight={700}
                >
                    {deltaText}
                </text>
            )} */}
            {/* actual value — just above bar */}
            <text
                x={x}
                y={y}
                fill="#f10b0b"
                textAnchor="middle"
                fontSize={11}
                fontWeight={600}
            >
                {value}
            </text>
        </g>
    );
};

export const getBarDomain = (data) => {
    const allValues = data.flatMap(d => [d.current ?? 0, d.prev ?? 0]);
    const max = Math.max(...allValues);
    return [0, Math.ceil(max * 1.25)]; // 25% headroom for top labels
};